document.addEventListener("DOMContentLoaded", function () {
  var ulElements = document.querySelectorAll('[data-steps-highlight="true"]');

  function addClassToCenterListItem(ul) {
    var listItems = ul.querySelectorAll("li");
    var viewportHeight = window.innerHeight;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    var centerViewport = scrollTop + viewportHeight / 2;

    var closestDistance = Number.MAX_VALUE;
    var centeredItem = null;
    var activeClass = "active";

    for (var i = 0; i < listItems.length; i++) {
      // Check if list item is direct descendant of ul
      if (listItems[i].parentNode !== ul) {
        continue;
      }

      var listItem = listItems[i];
      var listItemTop = listItem.getBoundingClientRect().top;
      var listItemHeight = listItem.offsetHeight;
      var listItemCenter = scrollTop + listItemTop + listItemHeight / 2;
      var distanceToCenter = Math.abs(listItemCenter - centerViewport);

      if (distanceToCenter < closestDistance) {
        closestDistance = distanceToCenter;
        centeredItem = listItem;
      }
    }

    // Remove 'active' class from all list items within the same ul
    listItems.forEach(function (item) {
      item.classList.remove(activeClass);
    });

    // Add 'active' class to the found centeredItem
    if (centeredItem) {
      centeredItem.classList.add(activeClass);
    }
  }

  function handleScroll() {
    for (var i = 0; i < ulElements.length; i++) {
      var ul = ulElements[i];
      addClassToCenterListItem(ul);
    }
  }

  window.addEventListener("scroll", handleScroll);
});
